// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard from 'src/components/shared/DashboardCard';
// import {
//     Button,
//     Grid,
//     MenuItem,
//     Select,
// } from '@mui/material';
// import { Box } from '@mui/system';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useMain } from '../hooks/useMain';
// import TextInputs from 'src/components/inputs/TextInputs';

// const initialValue = {
//     consumeableProductName: '',
//     productVolume: '',
//     productUnit: '',
//     consumeableProductCount: '',
//     // mappedServices: []
// };

// const initialFormValidation = {
//     consumeableProductNameValidation: false,
//     productVolumeValidation: false,
//     productUnitValidation: false,
//     consumeableProductCountValidation: false,
// };

// const AddConsumeProducts = () => {
//     const { createConsumeProduct, activeBranchId, getBranch, setShowMessage } = useMain();

//     const [formData, setFormData] = useState(initialValue);
//     const [formValidation, setFormValidation] = useState(initialFormValidation);
//     const [loading, setLoading] = useState(false);

//       const consumeableProductCountInputRef = useRef(null);
//     // Validation
//     const consumeableProductNameValidation = !formData.consumeableProductName.trim();
//     const productVolumeValidation = !formData.productVolume || Number(formData.productVolume) <= 0;
//     const productUnitValidation = !formData.productUnit || formData.productUnit.trim() === '';
//     const consumeableProductCountValidation = !formData.consumeableProductCount || Number(formData.consumeableProductCount) <= 0;
    
//            // Add this useEffect to focus on the product name field when component mounts
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (consumeableProductCountInputRef.current) {
//         consumeableProductCountInputRef.current.focus();
//       }
//     }, 100);
    
//     return () => clearTimeout(timer);
//   }, []);

//     // Input change with number validation
//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         // Handle number inputs
//         if (name === 'productVolume' || name === 'consumeableProductCount') {
//             // Only allow numbers and empty string
//             if (value === '' || /^[0-9\b]+$/.test(value)) {
//                 setFormData({ ...formData, [name]: value });
//             }
//         } else {
//             setFormData({ ...formData, [name]: value });
//         }
//     };

//     // Submit
//     const handleSubmit = async () => {
//         const { consumeableProductName, productVolume, productUnit, consumeableProductCount } = formData;

//         const validation = {
//             consumeableProductNameValidation: !consumeableProductName.trim(),
//             productVolumeValidation: !productVolume || Number(productVolume) <= 0,
//             productUnitValidation: !productUnit || productUnit.trim() === '',
//             consumeableProductCountValidation: !consumeableProductCount || Number(consumeableProductCount) <= 0,
//         };

//         setFormValidation(validation);
//         if (Object.values(validation).some((v) => v)) return;

//         try {
//             setLoading(true);
//             const payload = {
//                 ...formData,
//                 productVolume: Number(formData.productVolume),
//                 consumeableProductCount: Number(formData.consumeableProductCount),
//                 branchDetails: activeBranchId
//             };
//             const res = await createConsumeProduct(JSON.stringify(payload));
//             if (res?.statusCode === 200) {
//                 setShowMessage({
//                     message: res.message || 'Product created successfully',
//                     messageType: 'success',
//                 });
//                 setFormData(initialValue);
//                 setFormValidation(initialFormValidation);
//                 // setServiceSearch("");
//             } else {
//                 setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
//             }
//         } catch (error) {
//             setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <PageContainer title="Add New Product" description="Add new consumable product">
//             <DashboardCard title="Add Product Consumption">
//                 <Box mt={3}>
//                     <Grid container spacing={3}>
//                         <Grid item xs={12} md={4}>
//                             <TextInputs
//                                 ref={consumeableProductCountInputRef}
//                                 title="Product Name"
//                                 name="consumeableProductName"
//                                 value={formData.consumeableProductName}
//                                 handleChange={handleChange}
//                                 type="text"
//                                 placeholder="Product Name"
//                                 fieldValidation={consumeableProductNameValidation && formValidation.consumeableProductNameValidation}
//                             />
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                             <TextInputs
//                                 title="Volume"
//                                 name="productVolume"
//                                 placeholder="0"
//                                 value={formData.productVolume}
//                                 handleChange={handleChange}
//                                 type="text"
//                                 inputMode="numeric"
//                                 fieldValidation={productVolumeValidation && formValidation.productVolumeValidation}
//                             />
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                             <div style={{ marginBottom: '5px', fontWeight: 'bold' }}>Unit</div>
//                             <Select
//                                 name="productUnit"
//                                 value={formData.productUnit}
//                                 onChange={handleChange}
//                                 fullWidth
//                             >
//                                 {['ml', 'gm']?.map((type) => (
//                                     <MenuItem key={type} value={type}>
//                                         {type}
//                                     </MenuItem>
//                                 ))}
//                             </Select>
//                             {productUnitValidation && formValidation.productUnitValidation && (
//                                 <div style={{ color: 'red', fontSize: '0.8rem' }}>Please select a unit</div>
//                             )}
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                             <TextInputs
//                                 title="Product Count"
//                                 name="consumeableProductCount"
//                                 placeholder="0"
//                                 value={formData.consumeableProductCount}
//                                 handleChange={handleChange}
//                                 type="text"
//                                 inputMode="numeric"
//                                 fieldValidation={consumeableProductCountValidation && formValidation.consumeableProductCountValidation}
//                             />
//                         </Grid>
//                     </Grid>
//                 </Box>

//                 <Box mt={4} style={{ width: '200px', margin: '0 auto' }}>
//                     {loading ? (
//                         <ShowLoader />
//                     ) : (
//                         <Button
//                             variant="contained"
//                             fullWidth
//                             color="primary"
//                             sx={{ background: '#6174DD' }}
//                             onClick={handleSubmit}
//                         >
//                             Add Product
//                         </Button>
//                     )}
//                 </Box>
//             </DashboardCard>
//         </PageContainer>
//     );
// };

// export default AddConsumeProducts;

import React, { useState, useEffect, useMemo, useRef } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Grid, MenuItem, Select, FormControl, } from '@mui/material';
import { Box } from '@mui/system';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';

const initialValue = {
  consumeableProductName: '',
  productVolume: '',
  productUnit: '',
  consumeableProductCount: '',
  // mappedServices: []
};

const initialFormValidation = {
  consumeableProductNameValidation: false,
  productVolumeValidation: false,
  productUnitValidation: false,
  consumeableProductCountValidation: false,
};

const AddConsumeProducts = () => {
  const { createConsumeProduct, activeBranchId, setShowMessage } = useMain();

  const [formData, setFormData] = useState(initialValue);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [loading, setLoading] = useState(false);
  const consumeableProductCountInputRef = useRef(null);
  // Validation
  const consumeableProductNameValidation = !formData.consumeableProductName.trim();
  const productVolumeValidation = !formData.productVolume || Number(formData.productVolume) <= 0;
  const productUnitValidation = !formData.productUnit || formData.productUnit.trim() === '';
  // const consumeableProductCountValidation = !formData.consumeableProductCount || Number(formData.consumeableProductCount) <= 0;
  const consumeableProductCountValidation =
    formData.consumeableProductCount === '' || Number(formData.consumeableProductCount) < 0;

  // Add this useEffect to focus on the product name field when component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      if (consumeableProductCountInputRef.current) {
        consumeableProductCountInputRef.current.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);
  // Input change with number validation
  // const handleChange = (e) => {
  //     const { name, value } = e.target;

  //     // Handle number inputs
  //     if (name === 'productVolume' || name === 'consumeableProductCount') {
  //         // Only allow numbers and empty string
  //         if (value === '' || /^[0-9\b]+$/.test(value)) {
  //             setFormData({ ...formData, [name]: value });
  //         }
  //     } else {
  //         setFormData({ ...formData, [name]: value });
  //     }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // When unit changes
    if (name === 'productUnit') {
      if (value === 'pcs') {
        setFormData({
          ...formData,
          productUnit: value,
          productVolume: '1', // auto set volume
        });
      } else {
        setFormData({
          ...formData,
          productUnit: value,
        //   productVolume: '', // reset volume for ml/gm
        });
      }
      return;
    }

    // Handle number inputs
    if (name === 'productVolume' || name === 'consumeableProductCount') {
      if (value === '' || /^[0-9\b]+$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  // Remove only leading spaces while typing (spaces between words still work)
    const handleProductNameChange = (e) => {
        setFormData((prev) => ({ ...prev, consumeableProductName: e.target.value.trimStart() }));
    };

    // Trims trailing spaces when the user leaves the field
    const handleProductNameBlur = (e) => {
        const trimmed = e.target.value.trim();
        setFormData((prev) => ({ ...prev, consumeableProductName: trimmed }));
    };

    // Trims the pasted text, then inserts it at the cursor position
    const handleProductNamePaste = (e) => {
        e.preventDefault();
        const { selectionStart, selectionEnd, value } = e.target;
        const pasted = e.clipboardData.getData('text').trim();
        const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
        setFormData((prev) => ({ ...prev, consumeableProductName: next }));
    };


  // Submit
  const handleSubmit = async () => {
    const { consumeableProductName, productVolume, productUnit, consumeableProductCount } =
      formData;

    const validation = {
      consumeableProductNameValidation: !consumeableProductName.trim(),
      productVolumeValidation: !productVolume || Number(productVolume) <= 0,
      productUnitValidation: !productUnit || productUnit.trim() === '',
      consumeableProductCountValidation:
        consumeableProductCount === '' || Number(consumeableProductCount) < 0,
      // consumeableProductCountValidation: !consumeableProductCount || Number(consumeableProductCount) <= 0,
    };

    setFormValidation(validation);
    if (Object.values(validation).some((v) => v)) return;

    try {
      setLoading(true);
      const payload = {
        ...formData,
        productVolume: Number(formData.productVolume),
        consumeableProductCount: Number(formData.consumeableProductCount),
        branchDetails: activeBranchId,
      };
      const res = await createConsumeProduct(JSON.stringify(payload));
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Product created successfully',
          messageType: 'success',
        });
        setFormData(initialValue);
        setFormValidation(initialFormValidation);
        // setServiceSearch("");
      } else {
        setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer title="Add New Product" description="Add new consumable product">
      <DashboardCard title="Add Product Consumption">
        <Box mt={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <div onBlur={handleProductNameBlur} onPaste={handleProductNamePaste}>
              <TextInputs
                title="Product Name"
                ref={consumeableProductCountInputRef}
                name="consumeableProductName"
                value={formData.consumeableProductName}
                handleChange={handleProductNameChange}
                type="text"
                placeholder="Product Name"
                fieldValidation={
                  consumeableProductNameValidation &&
                  formValidation.consumeableProductNameValidation
                }
              />
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
                                <FormControl fullWidth>
                                    <label style={{
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        marginBottom: "2px",
                                        display: "block",
                                        color: "#212529",
                                        minHeight: '20px',
                                    }}>Volume</label>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            border: `1px solid ${
                                                (productVolumeValidation && formValidation.productVolumeValidation && formData.productUnit !== 'pcs') ||
                                                (productUnitValidation && formValidation.productUnitValidation)
                                                    ? 'red' : '#ced4da'
                                            }`,
                                            borderRadius: '4px',
                                            height: "57px",
                                            transition: 'border-color 0.2s ease-in-out',
                                            '&:hover': {
                                                borderColor: '#6174DD',
                                            },
                                        }}
                                    >
                                        <input
                                            name="productVolume"
                                            placeholder="0"
                                            value={formData.productVolume}
                                            onChange={handleChange}
                                            type="text"
                                            inputMode="numeric"
                                            disabled={formData.productUnit === 'pcs'}
                                            style={{
                                                border: 'none',
                                                outline: 'none',
                                                flex: 1,
                                                padding: '12px 12px',
                                                fontSize: '16px',
                                                background: 'transparent',
                                                width: '100%'
                                            }}
                                        />
                                        <Select
                                            name="productUnit"
                                            value={formData.productUnit}
                                            onChange={handleChange}
                                            displayEmpty
                                            renderValue={(selected) => selected ? selected : 'Unit'}
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            sx={{
                                                background: '#F0F0F0',
                                                border: 'none',
                                                height: '100%',
                                                minWidth: '90px',
                                                borderTopLeftRadius: '0px',
                                                borderBottomLeftRadius: '0px',
                                                borderTopRightRadius: '3px',
                                                borderBottomRightRadius: '3px',
                                                '& .MuiSelect-select': {
                                                    padding: '8px 16px',
                                                    paddingRight: '24px !important',
                                                    height: '100% !important',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    color: formData.productUnit ? '#000' : '#999',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none'
                                                },
                                                '&:hover': {
                                                    background: '#e0e0e0',
                                                },
                                                '&.Mui-focused': {
                                                    background: '#e0e0e0',
                                                },
                                                borderLeft: '1px solid #ced4da'
                                            }}
                                        >
                                            {['ml', 'gm', 'pcs']?.map((type) => (
                                                <MenuItem key={type} value={type}>
                                                    {type}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                    {productUnitValidation && formValidation.productUnitValidation && (
                                        <div style={{ color: 'red', fontSize: '0.8rem', marginTop: '4px' }}>Please select a unit</div>
                                    )}
                                </FormControl>
                            </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title="Product Count"
                                name="consumeableProductCount"
                                placeholder="0"
                                value={formData.consumeableProductCount}
                                handleChange={handleChange}
                                type="text"
                                inputMode="numeric"
                                fieldValidation={consumeableProductCountValidation && formValidation.consumeableProductCountValidation}
                            />
                        </Grid>
                    </Grid>
                </Box>

               <Box mt={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    {loading ? (
                        <ShowLoader />
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{ background: '#6174DD', width: '200px' }}
                            onClick={handleSubmit}
                        >
                            Add Product
                        </Button>
                    )}
                </Box>
            </DashboardCard>
        </PageContainer>
    );
};

export default AddConsumeProducts;